import React, { createContext, useContext, useState } from 'react';
import { LysepAPI } from './ApiContext';

const UserProfileContext = createContext();

export const useUserProfile = () => {
  const context = useContext(UserProfileContext);
  if (!context) {
    throw new Error('useUserProfile must be used within a UserProfileProvider');
  }
  return context;
};

export const UserProfileProvider = ({ children }) => {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Kendi profilini getir
  const getProfile = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await LysepAPI.get('/api/user/profile');
      
      if (response.data && response.data.state) {
        setProfile(response.data.user);
        return response.data.user;
      } else {
        throw new Error('Invalid response format');
      }
    } catch (error) {
      console.error('Get profile error:', error);
      setError(error.message);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  // Profili güncelle
  const updateProfile = async (profileData) => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await LysepAPI.put('/api/user/profile', profileData);
      
      if (response.data && response.data.state) {
        // Profili yeniden yükle
        await getProfile();
        return true;
      } else {
        throw new Error('Invalid response format');
      }
    } catch (error) {
      console.error('Update profile error:', error);
      setError(error.message);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return (
    <UserProfileContext.Provider value={{
      profile,
      loading,
      error,
      getProfile,
      updateProfile,
      setProfile
    }}>
      {children}
    </UserProfileContext.Provider>
  );
};

export default UserProfileContext;
